import React from 'react'
import { component_tool } from '@/tool'
const { WizLocationSelect } = component_tool

let componentName = 'siteOrderStatistic'

const columns = [
  {
    title: '场地名称',
    name: 'name',
    searchItem: {},
    tableItem: {}
  },
  {
    title: '场地编号',
    name: 'code',
    searchItem: {},
    tableItem: {}
  },
  {
    title: '场地应用类型',
    name: 'type',
    dict: [
      { code: 0, codeName: '教室' },
      { code: 1, codeName: '大门' },
      { code: 2, codeName: '餐厅' },
      { code: 3, codeName: '其他' }
    ],
    tableItem: {}
  },
  {
    title: '培训中心',
    name: 'center',
    tableItem: {}
  },
  {
    title: '城市',
    name: 'city',
    dataIndex: 'city',
    searchItem: {
      type: 'diy',
      diy: WizLocationSelect,
      showSearch: true,
      optionType: 'city'
    },
    tableItem: {},
  },
  {
    title: '组织',
    name: 'org',
    tableItem: {
      type: 'custom',
      render: (text, record) => {
        if (record && record.authInfo) {
          let { orgIds } = record.authInfo
          let value = ''
          orgIds && orgIds.length &&  orgIds.forEach(org => {
            value += org.name + ','
          })
          if (value.length) {
            value = value.substring(0, value.length - 1)
          }
          return <div>{value}</div>
        } else {
          return null
        }
      }
    }
  },
  {
    title: '岗位分类',
    name: 'positionCategory',
    tableItem: {
      type: 'custom',
      render: (text, record) => {
        if (record && record.authInfo) {
          let { positionCategoryIds } = record.authInfo
          let value = ''
          positionCategoryIds && positionCategoryIds.length &&  positionCategoryIds.forEach(positionCategory => {
            value += positionCategory.name + ','
          })
          if (value.length) {
            value = value.substring(0, value.length - 1)
          }
          return <div>{value}</div>
        } else {
          return null
        }
      }
    }
  },
  {
    title: '场地状态',
    name: 'status',
    dict: [
      { code: 0, codeName: '正常' },
      { code: 1, codeName: '停止使用' },
      { code: 2, codeName: '维修中' }
    ],
    searchItem: {
      type: 'select'
    },
    tableItem: {}
  },
  {
    title: '审核类型',
    name: 'auditType',
    dict: [
      { code: 0, codeName: '自动审核' },
      { code: 1, codeName: '手动审核' }
    ],
    tableItem: {}
  },
  {
    title: '核实次数',
    name: 'verifyCount',
    tableItem: {}
  },
  {
    title: '利用率',
    name: 'utilizationRate',
    tableItem: {}
  }
]

const templateConfig = {
  mainProps: {},
  content: {
    name: 'WizTableList',
    params: {
      columns,
      searchBarProps: {
        buttonSort: []
      },
      modalFormProps: {},
      dataTableProps: {
        rowKey: 'id',
        isScroll: true,
        loading: false
      },
      rowOperateSort: [],
      rowOperateView: []
    }
  }
}

const apis = {
  list: {
    path: `${componentName}/appointmentStatistic`,
    payload: {
      key: `${componentName}@appointmentStatistic`,
      apiParams: {}
    }
  }
}

let reduxTemplateCofig = (args) => {
  return {
    apis,
    componentName,
    initApiKeys: ['list'],
    needLoading: true,
    ...args
  }
}

export { reduxTemplateCofig, templateConfig }
